export default __webpack_public_path__ + "static/media/display_settings.e45c4781.svg";